import { css } from 'styled-components';
import altiboxSansVfWoff from '@lyse-as/formds-react/assets/fonts/Altibox Sans/AltiboxSansVF.woff';
import altiboxSansVfWoff2 from '@lyse-as/formds-react/assets/fonts/Altibox Sans/AltiboxSansVF.woff2';

export const fontPrimary = '"Altibox Sans"';

export const fonts = css`
  @font-face {
    font-family: ${fontPrimary};
    src:
      url(${altiboxSansVfWoff2}) format('woff2'),
      url(${altiboxSansVfWoff}) format('woff');
    font-weight: 100 900;
    font-style: normal;
  }

  @font-face {
    font-family: ${fontPrimary};
    src:
      url(${altiboxSansVfWoff2}) format('woff2'),
      url(${altiboxSansVfWoff}) format('woff');
    font-weight: 100 900;
    font-style: oblique 0deg 10deg;
  }
`;
